var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavanalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.613 12.3503C35.5464 8.73368 32.5297 5.71701 28.913 4.65034C26.163 3.85034 24.263 3.91701 22.9464 4.90034C21.363 6.08368 21.1797 8.21701 21.1797 9.73368V13.8837C21.1797 17.9837 23.0464 20.067 26.713 20.067H31.4964C32.9964 20.067 35.1464 19.8837 36.3297 18.3003C37.3464 17.0003 37.4297 15.1003 36.613 12.3503Z",
    fill: "#9E77ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32.015 23.0354C31.5817 22.5354 30.9484 22.252 30.2984 22.252H24.3317C21.3984 22.252 19.015 19.8687 19.015 16.9353V10.9687C19.015 10.3187 18.7317 9.68535 18.2317 9.25202C17.7484 8.81868 17.0817 8.61868 16.4484 8.70202C12.5317 9.20202 8.9317 11.352 6.5817 14.5854C4.21503 17.8354 3.34837 21.802 4.09837 25.7687C5.1817 31.502 9.76503 36.0853 15.515 37.1687C16.4317 37.352 17.3484 37.4353 18.265 37.4353C21.2817 37.4353 24.1984 36.502 26.6817 34.6854C29.915 32.3354 32.065 28.7353 32.565 24.8187C32.6484 24.1687 32.4484 23.5187 32.015 23.0354Z",
    fill: "#9E77ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavanalytics);
export default __webpack_public_path__ + "static/media/navanalytics.f74b60002078fcde0c5551070def3119.svg";
export { ForwardRef as ReactComponent };